import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  HolidayResponse,
  Holiday,
  AddHolidayResponse,
  HolidayCommonResponse,
} from '@core/interface/holiday';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class HolidayService {
  constructor(private http: HttpClient) {}

  getHolidays(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<HolidayResponse>(environment.endPoints.holidayList, {
      params: httpParams,
    });
  }

  addHoliday(data: Holiday) {
    return this.http.post<AddHolidayResponse>(
      environment.endPoints.holidayAddEdit,
      data
    );
  }
  deleteHoliday(id: number) {
    return this.http.get<HolidayCommonResponse>(
      environment.endPoints.holidayDelete(id)
    );
  }
}
